import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  record: [],
  unReadCount: '',
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setRecord(state, action) {
      state.record = action.payload;
    },
    setUnReadCount(state, action) {
      state.unReadCount = action.payload;
    },
  },
});

export const { setRecord, setUnReadCount } = notificationSlice.actions;

const notificationReducer = notificationSlice.reducer;
export default notificationReducer;
